import { useCallback, useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { PostCard } from "@/components/PostCard";
import { RetryBox } from "@/components/RetryBox";

const PAGE = 20;

export function usePosts(endpoint) {
  const [posts, setPosts] = useState(null);
  const [more, setMore] = useState(false);
  const [error, setError] = useState(false);
  const fetchPage = useCallback((before) => api.get(endpoint, { params: before ? { before } : {} }).then(({ data }) => { setMore(data.length === PAGE); return data; }), [endpoint]);
  const reload = useCallback(() => { setPosts(null); setError(false); fetchPage().then(setPosts).catch(() => setError(true)); }, [fetchPage]);
  useEffect(() => { reload(); }, [reload]);
  const loadMore = () => fetchPage(posts[posts.length - 1]?.created_at).then((d) => setPosts((l) => [...l, ...d]));
  const prepend = (p) => setPosts((l) => [p, ...(l || [])]);
  const remove = (id) => setPosts((l) => l.filter((p) => p.id !== id));
  return { posts, more, loadMore, prepend, remove, error, reload };
}

export function PostList({ feed, empty }) {
  const { posts, more, loadMore, remove, error, reload } = feed;
  if (error) return <RetryBox onRetry={reload} />;
  if (!posts) return <div className="flex justify-center py-12"><Loader2 className="w-6 h-6 animate-spin text-rose-500" /></div>;
  return (
    <div className="space-y-3 sm:space-y-4" data-testid="post-list">
      {posts.length === 0 && <p className="text-center text-sm text-slate-400 py-12" data-testid="post-list-empty">{empty}</p>}
      {posts.map((p) => <PostCard key={p.id} post={p} onRemoved={remove} />)}
      {more && <button onClick={loadMore} data-testid="post-list-more" className="mx-auto block px-6 h-11 rounded-full bg-white border border-pink-200 text-sm font-semibold text-rose-600 hover:bg-rose-50">Ältere Beiträge laden</button>}
    </div>
  );
}
